import { homeLoading, homeError, setHomeList } from "../../slices/homeSlice";
import {
  getService,
  createService,
  deleteAllService,
  deleteRowService,
  updateService,
  softDeleteService,
  softDeleteAllService,
  restoreRowService,
  restoreAllService,
  createSliderService,
  updateSlidersService,
} from "../../services/home";

export const getAction = (language) => async (dispatch) => {
  dispatch(homeLoading());
  try {
    const response = await getService(language);
    if (response?.error) {
      dispatch(homeError(response.error));
      return;
    } else {
      dispatch(setHomeList(response));
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const createAction = (formData) => async (dispatch) => {
  dispatch(homeLoading());
  try {
    const response = await createService(formData);
    if (response?.error) {
      dispatch(homeError(response.error));
      return;
    } else {
      dispatch(getAction());
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const createSliderAction = (formData) => async (dispatch) => {
  dispatch(homeLoading());
  try {
    const response = await createSliderService(formData);
    if (response?.error) {
      dispatch(homeError(response.error));
      return;
    } else {
      dispatch(getAction());
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const updateAction = (formData) => async (dispatch) => {
  const table = formData.get("table");
  const id = formData.get("id");
  dispatch(homeLoading());
  try {
    const response = await updateService(formData);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        homeError(`Failed to update row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const updateSlidersAction = (formData) => async (dispatch) => {
  const table = formData.get("table");
  const id = formData.get("id");
  dispatch(homeLoading());
  try {
    const response = await updateSlidersService(formData);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        homeError(`Failed to update row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const softDeleteAction = (table, id, username) => async (dispatch) => {
  dispatch(homeLoading());
  try {
    const response = await softDeleteService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        homeError(`Failed to softdelete row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const softDeleteAllAction =
  (table, type, username) => async (dispatch) => {
    dispatch(homeLoading());
    try {
      const response = await softDeleteAllService(table, type, username);
      if (response?.message) {
        dispatch(getAction());
        return;
      } else {
        dispatch(
          homeError(
            `Failed to delete records in ${table} table of type ${type}`
          )
        );
        return;
      }
    } catch (error) {
      dispatch(homeError(error.message));
      return;
    }
  };

export const deleteRowAction = (table, id, username) => async (dispatch) => {
  dispatch(homeLoading());
  try {
    const response = await deleteRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        homeError(`Failed to delete row with ID ${id} in table ${table}`)
      );
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const deleteAllAction = (table, type, username) => async (dispatch) => {
  dispatch(homeLoading());
  try {
    const response = await deleteAllService(table, type, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        homeError(`Failed to delete records in ${table} table of type ${type}`)
      );
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const restoreRowAction = (table, id, username) => async (dispatch) => {
  dispatch(homeLoading());
  try {
    const response = await restoreRowService(table, id, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        homeError(`Failed to recover row with ID ${id} in ${table} table`)
      );
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};

export const restoreAllAction = (table, type, username) => async (dispatch) => {
  dispatch(homeLoading());
  try {
    const response = await restoreAllService(table, type, username);
    if (response?.message) {
      dispatch(getAction());
      return;
    } else {
      dispatch(
        homeError(`Failed to recover records in ${table} table of type ${type}`)
      );
      return;
    }
  } catch (error) {
    dispatch(homeError(error.message));
    return;
  }
};
